<template>
    <div class="gas">
        <!-- 最上面部分 -->
        <div class="gas-right--head">
            <router-link to="/gasManage" class>加油站</router-link>&nbsp;/&nbsp;
            <span>订单管理</span>
        </div>
        <div class="gas-right--content">
            <!-- 搜索栏 -->
            <div class="o-flex o-alignCenter o-m-b-32">
                <div class="o-fs-14 o-m-r-14">订单号</div>
                <el-input v-model="tradeNo" placeholder="请输入订单号" style="width:155px;"></el-input>
                <div class="o-fs-14 o-m-r-14 o-m-l-26">会员手机号</div>
                <el-input v-model="shopMemberPhone" placeholder="请输入手机号码" style="width:155px;"></el-input>

                <el-date-picker
                    type="date"
                    placeholder="选择日期"
                    class="o-m-l-36"
                    style="width:166px;"
                    v-model="startTime"
                    format="yyyy 年 MM 月 dd 日"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>
                <div class="o-fs-14 o-m-l-14 o-m-r-14">至</div>
                <el-date-picker
                    type="date"
                    placeholder="选择日期"
                    style="width:166px;"
                    v-model="endTime"
                    format="yyyy 年 MM 月 dd 日"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>

                <el-select
                    class="o-m-l-36 o-m-r-36"
                    v-model="storeVal"
                    placeholder="请选择门店"
                    style="width:200px;"
                    @change="storeChange"
                >
                    <el-option
                        v-for="item in storeList.list"
                        :key="item.shopStoreId"
                        :label="item.storeName"
                        :value="item.shopStoreId"
                    ></el-option>
                </el-select>

                <el-select
                    class="o-m-r-32"
                    v-model="gunVal"
                    placeholder="选择油枪"
                    style="width:200px;"
                    v-if="gunList.length"
                >
                    <el-option
                        v-for="(item,index) in gunList"
                        :key="index"
                        :label="item.deviceNo"
                        :value="item.shopDeviceId"
                    ></el-option>
                </el-select>
                <el-button type="primary" round @click="onSearch">搜索</el-button>
                <el-button type="success" round @click="onReset">重置</el-button>
            </div>
            <!-- 表单 -->
            <div class="tables" v-for="(item, index) in list" :key="index" v-loading="tabLoading">
                <div class="tables-head">
                    订单号：{{item.tradeNo}}
                    <el-link
                        class="o-m-l-10"
                        type="primary"
                        v-clipboard:copy="item.tradeNo"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                    >复制</el-link>
                </div>
                <div class="tables-content">
                    <div class="item">
                        <div>{{item.storeName}}</div>
                        <div>{{item.productData.industryGoodsDesc}}({{item.productData.buyCount}}{{item.productData.goodsUnit}})</div>
                        <div>{{item.productData.buyCount}}{{item.productData.goodsUnit}}</div>
                        <div>{{item.productData.deviceNo}}号油枪</div>
                    </div>
                    <div class="item">
                        <div>{{item.storeName}}</div>
                    </div>
                    <div class="item">
                        <div>下单时间</div>
                        <div class="o-m-b-16 gray">{{item.createTime}}</div>
                        <div v-if="item.orderStatus==10">未付款</div>
                        <div v-if="item.orderStatus==40">完成</div>
                        <div v-if="item.orderStatus==-10">关闭订单</div>
                        <div v-if="item.orderStatus==-20">取消订单</div>
                        <div v-if="item.orderStatus==-50">退款</div>

                        <!-- <div>支付时间</div>
                        <div class="gray">2020-06-22 11:54:25</div>-->
                    </div>
                    <div class="item">
                        <div>合计：￥{{item.totalRetailPrice}}</div>
                        <div>会员优惠：-￥{{item.discountPrice?item.discountPrice:0}}</div>
                        <div>优惠券：-￥{{item.cashCouponTotalPrice?item.cashCouponTotalPrice:0}}</div>
                        <div>获取积分：{{item.userScore?item.userScore:0}}</div>
                        <div>折后金额：{{item.totalTurnoverPrice}}</div>
                    </div>
                    <div class="item">
                        <el-button type="primary" round size="small" @click="onLodop(item)">打印</el-button>
                    </div>
                </div>
            </div>
            <!-- 分页 -->
            <el-pagination
                class="o-m-t-30"
                background
                layout="prev, pager, next"
                :total="count"
                @current-change="onPageChange"
                :page-size="5"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
import {
    gasOrders,
    gasOrdersCount,
    Shop_shopStores,
    gasDevices,
} from "@/components/api/index.js";
export default {
    data() {
        return {
            page: 1,
            count: 1,
            list: [],
            storeList: [],
            userList: [],
            gunList: [],
            storeVal: null,
            gunVal: null,
            tradeNo: "",
            shopMemberPhone: "",
            startTime: "",
            endTime: "",
            tabLoading: false,
        };
    },
    created() {
        this.userList = this.getCookie("userList")
            ? JSON.parse(this.getCookie("userList"))
            : "";
    },
    async mounted() {
        await this.getShopStores();
        this.onSearch();
    },
    methods: {
        onLodop(e) {
            let template_html = `
            <form id="from">
                <div class="center column">
                    <div class="center shopName boldFont">${e.storeName}</div>
                </div>
                <div class="content1">
                    <div>油品：${e.productData.industryGoodsDesc}</div>
                    <div>油枪：${e.productData.deviceNo}</div>
                    <div>加油升数：${e.productData.buyCount}</div>
                    <div>下单时间：${e.createTime}</div>
                </div>
                <div class="br"></div>
                <div class="content1">
                    <div>合计：${e.totalRetailPrice}</div>
                    <div>会员优惠：-￥${
                        e.discountPrice ? e.discountPrice : 0
                    }</div>
                    <div>优惠券：${
                        e.cashCouponTotalPrice ? e.cashCouponTotalPrice : 0
                    }</div>
                    <div>获取积分：${e.userScore ? item.userScore : 0}</div>
                    <div>折后金额：${e.totalTurnoverPrice}</div>
                </div>
            </form>
            <style>
                #from{
                font-size: 12px;
                padding-right:5px
                }
                .br{  
                border-bottom: 1px dashed  #000;
                margin: 10px 0;
                }
                .boldFont{
                font-size: 22px;
                font-weight: 600;
                }
                .shopName{
                margin-bottom:20px;
                
                }
                .center {
                display: flex;
                align-items: center;
                justify-content: center;
                }

                .row {
                display: flex;
                flex-direction: row;
                }

                .column {
                display: flex;
                flex-direction: column;
                }

                .justCenter {
                display: flex;
                justify-content: center;
                }

                .alignCenter {
                display: flex;
                align-items: center;
                }
                .flex-between {
                display: flex;
                justify-content: space-between;
                }</style>`;
            LODOP.PRINT_INIT("订单小票");
            LODOP.ADD_PRINT_HTM(0, 0, "100%", "100%", template_html);
            LODOP.SET_PRINT_PAGESIZE(3, 600, 40, "");
            // LODOP.PREVIEW(); //预览
            LODOP.PRINT(); //打印

            console.log(LODOP);
        },
        onCopy(e) {
            this.$message({
                type: "success",
                message: "复制成功!",
            });
        },
        onError(e) {
            this.$message({
                type: "warning",
                message: "复制失败!",
            });
        },
        gasOrders() {
            this.tabLoading = true;
            return gasOrders({
                pageNo: this.page,
                row: 5,
                tradeNo: this.tradeNo,
                shopMemberPhone: this.shopMemberPhone,
                shopStoreId: this.storeVal,
                startDate: this.startTime,
                endDate: this.endDate,
                shopDeviceId: this.gunVal,
            }).then((res) => {
                this.tabLoading = false;
                this.list = [];
                if (res.code == 1) {
                    let arr = JSON.parse(JSON.stringify(res.data));
                    arr.forEach((e) => {
                        let productData = JSON.parse(e.productData);
                        this.storeList.list.forEach((element) => {
                            if (e.shopStoreId == element.shopStoreId) {
                                e.storeName = element.storeName;
                            }
                        });
                        e.productData = productData;
                    });

                    this.list = arr;
                }
            });
        },
        getShopStores() {
            return Shop_shopStores({
                sessionId: this.userList.sessionId,
                userId: this.userList.id,
            }).then((res) => {
                if (res.code == 1) {
                    this.storeList = res.data;
                }
            });
        },
        gasDevices() {
            gasDevices({
                shopStoreId: this.storeVal,
                pageNo: 1,
                row: 1000,
            })
                .then((res) => {
                    if (res.code == 1) {
                        this.gunList = res.data;
                    } else {
                        this.gunList = [];
                    }
                })
                .catch((err) => {
                    this.gunList = [];
                });
        },
        gasOrdersCount() {
            return gasOrdersCount({
                tradeNo: this.tradeNo,
                shopMemberPhone: this.shopMemberPhone,
                shopStoreId: this.storeVal,
                startDate: this.startTime,
                endDate: this.endDate,
                shopDeviceId: this.gunVal,
            }).then((res) => {
                if (res.code == 1) {
                    this.count = res.data;
                }
            });
        },
        async onSearch() {
            await this.gasOrders();
            await this.gasOrdersCount();
        },
        onReset() {
            this.page = 1;
            this.count = 1;
            this.startTime = "";
            this.endTime = "";
            this.storeVal = "";
            this.gunVal = "";
            this.tradeNo = "";
            this.gunList = [];
            this.onSearch();
        },
        storeChange(e) {
            console.log(e);
            this.gasDevices();
        },
        onPageChange(e) {
            //改变页数
            this.page = e;
            this.onSearch();
        },
    },
};
</script>
<style lang="scss" scoped>
.gas {
    width: calc(100vw - 200px);
    height: calc(100vh);
    margin-left: 200px;
    min-width: 1340px;
    background-color: #f8f8f8;
    padding-top: 87px;
    box-sizing: border-box;
    padding-right: 25px;
}
.gas-right--head {
    height: 66px;
    line-height: 66px;
    background-color: #fff;
    padding-left: 31px;
    font-weight: 400;
    display: inline-flex;
    align-items: center;
    width: 100%;
    box-sizing: border-box;
    position: fixed;
    top: 0;
    font-size: 14px;
    a {
        color: #333333;
    }
    span {
        color: #5f6165;
    }
}
.gas-right--content {
    padding: 22px 30px 40px 26px;
    // padding: 87px 25px 0 28px;
    width: 100%;
    box-sizing: border-box;
    background-color: #fff;
}

.tables {
    .tables-head {
        height: 49px;
        background: rgba(247, 247, 247, 1);
        // line-height: 49px;
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: bold;
        color: rgba(143, 147, 153, 1);
        padding-left: 16px;
    }
    .tables-content {
        display: flex;

        .item {
            border-top: 1px solid rgba(235, 237, 245, 1);
            border-left: 1px solid rgba(235, 237, 245, 1);
            border-bottom: 1px solid rgba(235, 237, 245, 1);
            flex: 1;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(95, 97, 101, 1);
            line-height: 24px;
            height: 177px;
            padding: 38px 0 0 5%;
            box-sizing: border-box;
            // text-align: center;
            &:nth-child(5) {
                padding: 0;
                text-align: center;
                line-height: 177px;
                border-right: 1px solid rgba(235, 237, 245, 1);
            }
            .gray {
                color: #999;
            }
        }
    }
}
</style>





// WEBPACK FOOTER //
// src/components/page/gasOrder.vue